(()=>{if(window.__emForce)return;window.__emForce=1;
/* Les animations ENVOL s'affichent sur tous les appareils: on ignore la preference systeme "reduire les animations". */
const RE=/prefers-reduced-motion/i,orig=window.matchMedia.bind(window);
window.matchMedia=q=>orig(RE.test(String(q))?'not all':q);
const strip=()=>{for(const sh of [...document.styleSheets]){let rules;try{rules=sh.cssRules}catch(e){continue}
for(let i=rules.length-1;i>=0;i--){const r=rules[i];if(r.type===CSSRule.MEDIA_RULE&&RE.test(r.conditionText||r.media.mediaText))try{sh.deleteRule(i)}catch(e){}}}};
strip();document.addEventListener('DOMContentLoaded',strip);addEventListener('load',strip);
})();
